import React from "react"
import USMap from "../../QuarterlyReport/USMap"
import type { GeographicExposureData } from "~/api/quarterly_reports"

interface GeographicDonutProps {
  exposure: { region: string; mv: number }[] | undefined
}

function toUSMapData(
  exposure: { region: string; mv: number }[],
): GeographicExposureData[] {
  const totalMv = exposure.reduce((sum, r) => sum + r.mv, 0)
  return exposure.map((r) => ({
    geographic_region: r.region,
    qpcsp_weighting: totalMv > 0 ? (r.mv / totalMv) * 100 : 0,
    equity: 0,
    venture_capital: 0,
    real_assets: 0,
    credit: 0,
    is_total: false,
  }))
}

export default function GeographicDonut({ exposure }: GeographicDonutProps) {
  const items = (exposure ?? []).filter((r) => r.mv > 0)

  if (items.length === 0) {
    return <div className="b-ps-no-data">No geographic data available.</div>
  }

  return (
    <div className="b-ps-us-map-wrap">
      <USMap data={toUSMapData(items)} />
    </div>
  )
}
